import { FC, useId, MouseEvent } from 'react';
import { useFragment, graphql } from 'react-relay';
import { getSrcsetString } from 'dibs-image-utils/exports/srcSet';
import { useRespUnavailableContext } from '../PdpRespUnavailableContext/PdpRespUnavailableContext';

// components
import { Link } from 'dibs-elements/exports/Link';
import { AuctionPricePaddle } from 'dibs-auctions/exports/AuctionPricePaddle';

// styles
import styles from './PdpRespUnavailableHeaderYMALItem.scss';

// types
import { PdpRespUnavailableHeaderYMALItem_item$key as Item } from './__generated__/PdpRespUnavailableHeaderYMALItem_item.graphql';

const itemFragment = graphql`
    fragment PdpRespUnavailableHeaderYMALItem_item on Item {
        isArt
        title
        pdpURL
        serviceId
        creators {
            creator {
                name
            }
        }
        photos(limit: 1) {
            masterOrZoomPath
        }
        ...AuctionPricePaddle_item
    }
`;

export const PdpRespUnavailableHeaderYMALItem: FC<{
    index: number;
    item: Item;
    onClick?: (index: number, event: MouseEvent) => void;
}> = ({ item: itemRef, onClick = () => {}, index }) => {
    const htmlId = useId();
    const item = useFragment(itemFragment, itemRef);
    const { isArt, title, pdpURL, creators, photos } = item || {};
    const creatorName = creators?.[0]?.creator?.name;
    const imagePath = photos?.[0]?.masterOrZoomPath;
    const { currency } = useRespUnavailableContext();

    return (
        <div className={styles.container} data-tn="pdp-similar-item">
            <Link
                id={htmlId}
                underline="none"
                href={pdpURL || ''}
                className={styles.overlayLink}
                onClick={event => onClick(index, event)}
            >
                <div className={styles.overlayLinkSqueeze}>
                    {isArt && creatorName && `${creatorName} - `}
                    {title}
                </div>
            </Link>
            {imagePath && (
                <div className={styles.imageWrapper}>
                    <img
                        className={styles.image}
                        aria-labelledby={htmlId}
                        srcSet={getSrcsetString(imagePath)}
                        sizes="16vw"
                        alt={title || ''}
                        src={imagePath}
                    />
                </div>
            )}
            {item && <AuctionPricePaddle item={item} currency={currency} showPill />}
        </div>
    );
};
